var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1057.32px",
    height: "342.99px",
    viewBox: "0 0 1057.32 342.99",
    enableBackground: "new 0 0 1057.32 342.99",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.396,
    y: -10.246,
    display: "inline",
    fill: "#5F5E5E",
    width: 1076.112,
    height: 363.482
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "248.428,135.235 271.62,135.235 271.62,124.954 218.094,124.954 218.094,135.489 248.428,135.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "271.619,113.979 248.425,113.979 248.425,106.172 273.818,106.172 273.818,83.833 218.094,83.833  218.094,119.517 271.619,119.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "248.428,140.548 218.094,140.548 218.094,165.603 274.698,165.603 274.698,143.262  248.428,143.262  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M173.68,132.634h-0.668l-1.797-7.68H151.1l2.259,10.531h43.827l3.796-10.531h-26.433 C174.185,127.523,173.914,130.106,173.68,132.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M175.784,118.209c-0.098,0.429-0.176,0.873-0.27,1.305h27.431l12.869-35.681h-31.604L175.784,118.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161.593,83.833h-23.287l-8.874,33.725c-0.172,0.646-0.312,1.305-0.461,1.959h40.97L161.593,83.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M126.886,132.632h-0.667l-1.658-7.68H98.913l3.771,10.537h44.526l0.524-1.985 c0.689-2.8,1.006-5.647,1.246-8.552h-21.097C127.479,127.523,127.164,130.106,126.886,132.632"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "84.194,83.833 96.967,119.517 123.388,119.517 115.685,83.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "159.82,165.601 186.322,165.601 195.358,140.548 154.442,140.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "113.469,165.601 139.303,165.601 145.881,140.548 104.5,140.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "455.636,82.718 455.636,110.267 437.168,110.267 437.168,82.718 408.155,82.718 408.155,119.517  484.65,119.517 484.65,82.718  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.637,
    y: 140.548,
    fill: "#FFFFFF",
    width: 29.013,
    height: 23.943
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.158,
    y: 140.548,
    fill: "#FFFFFF",
    width: 29.011,
    height: 23.943
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M356.107,119.517h46.46c0.012-0.686,0.02-1.369,0.029-2.069h-46.489V119.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M342.04,126.452c0-0.502,0.025-0.998,0.06-1.498h-30.382c-0.006,0.105-0.016,0.202-0.016,0.305 c0,3.621,0.41,7.033,1.142,10.23h31.304C342.775,132.78,342.04,129.651,342.04,126.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M358.747,107.474c4.834,0,9.117,2.166,11.431,6.293l28.136-10.195 c-6.483-13.99-26.271-21.039-40.665-21.039c-24.118,0-42.951,13.765-45.608,36.984h31.043 C345.219,112.701,350.593,107.474,358.747,107.474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M357.539,143.913c-3.793,0-6.968-1.285-9.439-3.365h-33.736c6.306,16.83,23.188,26.357,43.065,26.357 c12.86,0,26.376-5.1,35.17-14.531c3.584-3.82,5.849-7.74,7.299-11.826h-32.589C364.739,142.858,360.823,143.913,357.539,143.913"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M356.107,135.485h45.174c0.688-3.373,0.989-6.871,1.142-10.531h-46.315V135.485z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.125,
    y: 83.833,
    fill: "#FFFFFF",
    width: 30.113,
    height: 35.684
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.125,
    y: 124.954,
    fill: "#FFFFFF",
    width: 30.113,
    height: 10.531
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.125,
    y: 140.55,
    fill: "#FFFFFF",
    width: 30.113,
    height: 25.051
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.158,
    y: 124.954,
    fill: "#FFFFFF",
    width: 76.492,
    height: 10.531
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M838.456,88.434h4.247c1.153,0,2.245,0.502,2.245,2.034c0,1.51-1.3,2.008-2.245,2.008h-4.247V88.434z  M832.965,105.261h10.125c4.519,0,8.202-1.535,8.202-6.556c0-2.391-1.384-4.337-3.628-4.985c1.654-0.826,2.77-2.364,2.77-4.256 c0-4.396-3.98-5.342-7.609-5.283h-9.859V105.261z M838.456,96.022h4.396c1.652,0,2.954,0.619,2.954,2.481 c0,1.739-1.209,2.361-2.954,2.361h-4.396V96.022z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.112,
    y: 84.184,
    fill: "#FFFFFF",
    width: 5.496,
    height: 21.077
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "861.252,105.261 876.577,105.261 876.577,100.538 866.745,100.538 866.745,84.181 861.252,84.181  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M875.963,105.261h5.639l1.331-3.777h7.351l1.293,3.777h5.729l-7.881-21.08h-5.577L875.963,105.261z  M886.59,90.03h0.056l2.335,7.379H884.2L886.59,90.03z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "897.668,105.261 902.834,105.261 902.834,92.126 902.895,92.126 910.221,105.261 915.856,105.261  915.856,84.181 910.686,84.181 910.686,97.173 910.63,97.173 903.307,84.181 897.668,84.181  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M937.918,91.712c-0.146-5.079-5.078-7.972-9.623-7.972c-6.377,0-10.508,4.872-10.508,10.98 c0,6.115,4.131,10.981,10.508,10.981c5.345,0,9.332-3.186,9.623-8.62h-5.486c-0.211,2.423-1.688,3.899-4.256,3.899 c-3.538,0-4.901-3.131-4.901-6.261c0-3.126,1.363-6.258,4.901-6.258c2.306,0,3.957,1.124,4.256,3.249H937.918z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 939.673,
    y: 84.184,
    fill: "#FFFFFF",
    width: 5.493,
    height: 21.077
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M945.655,105.261h5.639l1.325-3.777h7.355l1.302,3.777H967l-7.885-21.08h-5.584L945.655,105.261z  M956.282,90.03h0.062l2.335,7.379h-4.787L956.282,90.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 967.417,
    y: 84.184,
    fill: "#FFFFFF",
    width: 5.49,
    height: 21.077
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M408.196,242.524c0-0.149,0.101-0.254,0.254-0.254h2.49c0.151,0,0.254,0.104,0.254,0.254v16.78 c0,0.149-0.103,0.254-0.254,0.254h-2.49c-0.153,0-0.254-0.104-0.254-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M415.008,242.524c0-0.149,0.1-0.254,0.254-0.254h2.338c0.203,0,0.332,0.078,0.437,0.254l7.039,11.924 h0.098v-11.924c0-0.149,0.103-0.254,0.254-0.254h2.212c0.152,0,0.255,0.104,0.255,0.254v16.78c0,0.149-0.103,0.254-0.255,0.254 h-2.313c-0.2,0-0.333-0.081-0.434-0.254l-7.063-11.9h-0.101v11.9c0,0.149-0.1,0.254-0.254,0.254h-2.213 c-0.154,0-0.254-0.104-0.254-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M431.71,242.524c0-0.149,0.103-0.252,0.257-0.252h6.175c2.972,0,4.959,1.32,5.772,3.833 c0.273,0.864,0.43,1.81,0.43,4.808c0,3-0.156,3.94-0.43,4.805c-0.813,2.519-2.801,3.838-5.772,3.838h-6.175 c-0.154,0-0.257-0.1-0.257-0.254V242.524z M434.864,256.864h2.567c1.911,0,3.072-0.637,3.58-2.191 c0.18-0.479,0.308-1.27,0.308-3.76c0-2.516-0.128-3.275-0.308-3.76c-0.508-1.556-1.669-2.189-3.58-2.189h-2.567 c-0.102,0-0.152,0.056-0.152,0.154v11.595C434.711,256.81,434.762,256.864,434.864,256.864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M457.236,253.429v-10.902c0-0.151,0.099-0.254,0.251-0.254h2.496c0.146,0,0.248,0.103,0.248,0.254v10.955 c0,4.014-2.718,6.357-6.378,6.357c-3.633,0-6.354-2.344-6.354-6.357v-10.955c0-0.151,0.101-0.254,0.254-0.254h2.496 c0.151,0,0.254,0.103,0.254,0.254v10.902c0,2.391,1.395,3.71,3.351,3.71C455.833,257.139,457.236,255.819,457.236,253.429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M463.032,257.548c-0.1-0.1-0.154-0.254-0.052-0.38l1.577-1.827c0.104-0.129,0.259-0.129,0.354-0.032 c1.121,0.89,2.775,1.83,4.705,1.83c2.063,0,3.255-1.039,3.255-2.487c0-1.246-0.762-2.057-3.151-2.391l-0.916-0.125 c-3.33-0.461-5.21-2.063-5.21-4.936c0-3.123,2.284-5.207,5.847-5.207c2.156,0,4.221,0.686,5.59,1.725 c0.131,0.105,0.151,0.205,0.052,0.359l-1.222,1.877c-0.102,0.128-0.228,0.154-0.354,0.081c-1.397-0.917-2.695-1.351-4.145-1.351 c-1.752,0-2.717,0.971-2.717,2.316c0,1.191,0.833,2.006,3.174,2.338l0.915,0.129c3.329,0.455,5.161,2.029,5.161,5.006 c0,3.074-2.211,5.362-6.506,5.362C466.844,259.836,464.385,258.82,463.032,257.548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.711,259.556c-0.15,0-0.258-0.1-0.258-0.254v-14.186c0-0.1-0.044-0.148-0.146-0.148h-4.528 c-0.151,0-0.251-0.104-0.251-0.254v-2.184c0-0.158,0.1-0.26,0.251-0.26h12.354c0.151,0,0.254,0.102,0.254,0.26v2.184 c0,0.15-0.103,0.254-0.254,0.254h-4.525c-0.104,0-0.149,0.049-0.149,0.148v14.186c0,0.154-0.103,0.254-0.257,0.254H482.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M502.668,259.559c-0.203,0-0.305-0.081-0.38-0.254l-3.306-6.739h-2.975c-0.104,0-0.156,0.053-0.156,0.151 v6.588c0,0.149-0.1,0.254-0.25,0.254h-2.49c-0.152,0-0.257-0.104-0.257-0.254v-16.778c0-0.151,0.104-0.256,0.257-0.256h6.682 c3.177,0,5.52,2.113,5.52,5.16c0,2.266-1.298,4.02-3.278,4.755l3.634,7.04c0.097,0.178,0,0.333-0.176,0.333H502.668z  M502.335,247.431c0-1.5-1.063-2.463-2.645-2.463h-3.683c-0.104,0-0.156,0.046-0.156,0.15v4.602c0,0.102,0.052,0.15,0.156,0.15 h3.683C501.272,249.87,502.335,248.905,502.335,247.431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M508.593,242.524c0-0.149,0.103-0.254,0.251-0.254h2.492c0.156,0,0.258,0.104,0.258,0.254v16.78 c0,0.149-0.102,0.254-0.258,0.254h-2.492c-0.148,0-0.251-0.104-0.251-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M519.879,242.526c0.053-0.154,0.154-0.256,0.331-0.256h2.337c0.18,0,0.281,0.102,0.332,0.256l5.847,16.775 c0.052,0.152,0,0.254-0.177,0.254h-2.492c-0.18,0-0.281-0.078-0.333-0.254l-1.144-3.357h-6.501l-1.148,3.357 c-0.052,0.176-0.151,0.254-0.331,0.254h-2.464c-0.183,0-0.229-0.102-0.183-0.254L519.879,242.526z M523.668,253.277l-2.289-6.711 h-0.078l-2.311,6.711H523.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M531.092,242.524c0-0.149,0.102-0.254,0.257-0.254h2.487c0.157,0,0.256,0.104,0.256,0.254v14.186 c0,0.102,0.053,0.154,0.152,0.154h7.931c0.154,0,0.254,0.103,0.254,0.251v2.189c0,0.149-0.1,0.254-0.254,0.254h-10.826 c-0.155,0-0.257-0.104-0.257-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M562.26,259.556c-0.149,0-0.252-0.1-0.31-0.254l-3.299-11.821H558.6l-3.331,11.821 c-0.05,0.154-0.155,0.254-0.307,0.254h-1.903c-0.151,0-0.254-0.1-0.309-0.254l-4.244-16.771c-0.018-0.158,0.029-0.26,0.21-0.26 h2.388c0.175,0,0.28,0.102,0.301,0.26l2.746,11.637h0.053l3.229-11.637c0.053-0.158,0.152-0.26,0.304-0.26h1.78 c0.176,0,0.257,0.102,0.304,0.26l3.304,11.637h0.053l2.668-11.637c0.026-0.182,0.152-0.26,0.304-0.26h2.364 c0.175,0,0.228,0.102,0.207,0.26l-4.221,16.771c-0.023,0.154-0.152,0.254-0.307,0.254H562.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M571.037,242.524c0-0.149,0.097-0.254,0.255-0.254h10.828c0.148,0,0.252,0.104,0.252,0.254v2.191 c0,0.148-0.104,0.252-0.252,0.252h-7.93c-0.104,0-0.155,0.049-0.155,0.15v4.221c0,0.104,0.052,0.149,0.155,0.149h6.678 c0.154,0,0.257,0.105,0.257,0.257v2.187c0,0.149-0.103,0.254-0.257,0.254h-6.678c-0.104,0-0.155,0.052-0.155,0.151v4.373 c0,0.102,0.052,0.154,0.155,0.154h7.93c0.148,0,0.252,0.103,0.252,0.251v2.189c0,0.149-0.104,0.254-0.252,0.254h-10.828 c-0.158,0-0.255-0.104-0.255-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M585.526,242.524c0-0.149,0.103-0.254,0.258-0.254h2.486c0.152,0,0.257,0.104,0.257,0.254v16.78 c0,0.149-0.104,0.254-0.257,0.254h-2.486c-0.155,0-0.258-0.104-0.258-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M591.831,250.913c0-2.718,0.097-3.684,0.459-4.752c0.891-2.747,3.123-4.172,6.173-4.172 c3.229,0,5.315,1.729,6.028,3.66c0.049,0.129,0.023,0.281-0.103,0.359l-2.134,0.94c-0.158,0.05-0.28-0.026-0.336-0.126 c-0.759-1.371-1.807-2.143-3.479-2.143c-1.752,0-2.771,0.87-3.256,2.269c-0.197,0.634-0.303,1.497-0.303,3.964 c0,2.439,0.105,3.33,0.303,3.967c0.485,1.395,1.504,2.259,3.256,2.259c1.525,0,2.822-0.762,3.277-2.159 c0.181-0.531,0.28-1.247,0.28-2.236c0-0.103-0.05-0.148-0.151-0.148h-2.844c-0.157,0-0.257-0.105-0.257-0.258v-2.034 c0-0.155,0.1-0.254,0.257-0.254h5.715c0.152,0,0.258,0.099,0.258,0.254v1.501c0,1.427-0.129,2.924-0.409,3.785 c-0.841,2.7-3.129,4.247-6.104,4.247c-3.05,0-5.282-1.421-6.173-4.165C591.927,254.6,591.831,253.63,591.831,250.913"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M608.282,242.524c0-0.149,0.102-0.254,0.254-0.254h2.49c0.151,0,0.256,0.104,0.256,0.254v6.814 c0,0.104,0.051,0.149,0.149,0.149h6.582c0.104,0,0.151-0.046,0.151-0.149v-6.814c0-0.149,0.108-0.254,0.26-0.254h2.487 c0.157,0,0.257,0.104,0.257,0.254v16.78c0,0.149-0.1,0.254-0.257,0.254h-2.487c-0.151,0-0.26-0.104-0.26-0.254v-6.968 c0-0.1-0.047-0.151-0.151-0.151h-6.582c-0.099,0-0.149,0.052-0.149,0.151v6.968c0,0.149-0.104,0.254-0.256,0.254h-2.49 c-0.152,0-0.254-0.104-0.254-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M624.987,242.524c0-0.149,0.096-0.254,0.25-0.254h2.493c0.151,0,0.251,0.104,0.251,0.254v16.78 c0,0.149-0.1,0.254-0.251,0.254h-2.493c-0.154,0-0.25-0.104-0.25-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M631.799,242.524c0-0.149,0.1-0.254,0.251-0.254h2.341c0.204,0,0.33,0.078,0.432,0.254l7.041,11.924h0.104 v-11.924c0-0.149,0.1-0.254,0.251-0.254h2.213c0.152,0,0.254,0.104,0.254,0.254v16.78c0,0.149-0.102,0.254-0.254,0.254h-2.318 c-0.201,0-0.323-0.081-0.428-0.254l-7.062-11.9h-0.104v11.9c0,0.149-0.105,0.254-0.258,0.254h-2.212 c-0.151,0-0.251-0.104-0.251-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M647.993,250.913c0-2.718,0.1-3.684,0.461-4.752c0.888-2.747,3.124-4.172,6.174-4.172 c3.231,0,5.31,1.729,6.027,3.66c0.047,0.129,0.023,0.281-0.104,0.359l-2.137,0.94c-0.151,0.05-0.283-0.026-0.327-0.126 c-0.765-1.371-1.81-2.143-3.482-2.143c-1.76,0-2.77,0.87-3.254,2.269c-0.205,0.634-0.307,1.497-0.307,3.964 c0,2.439,0.102,3.33,0.307,3.967c0.484,1.395,1.494,2.259,3.254,2.259c1.521,0,2.816-0.762,3.275-2.159 c0.178-0.531,0.283-1.247,0.283-2.236c0-0.103-0.056-0.148-0.158-0.148h-2.843c-0.154,0-0.257-0.105-0.257-0.258v-2.034 c0-0.155,0.103-0.254,0.257-0.254h5.718c0.155,0,0.258,0.099,0.258,0.254v1.501c0,1.427-0.132,2.924-0.409,3.785 c-0.841,2.7-3.123,4.247-6.101,4.247c-3.05,0-5.286-1.421-6.174-4.165C648.092,254.6,647.993,253.63,647.993,250.913"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M669.526,257.548c-0.103-0.1-0.154-0.254-0.05-0.38l1.576-1.827c0.103-0.129,0.257-0.129,0.356-0.032 c1.117,0.89,2.767,1.83,4.702,1.83c2.063,0,3.251-1.039,3.251-2.487c0-1.246-0.762-2.057-3.148-2.391l-0.917-0.125 c-3.327-0.461-5.208-2.063-5.208-4.936c0-3.123,2.286-5.207,5.844-5.207c2.163,0,4.221,0.686,5.599,1.725 c0.122,0.105,0.146,0.205,0.047,0.359l-1.22,1.877c-0.105,0.128-0.23,0.154-0.362,0.081c-1.396-0.917-2.691-1.351-4.142-1.351 c-1.752,0-2.718,0.971-2.718,2.316c0,1.191,0.841,2.006,3.176,2.338l0.917,0.129c3.327,0.455,5.16,2.029,5.16,5.006 c0,3.074-2.213,5.362-6.506,5.362C673.34,259.836,670.872,258.82,669.526,257.548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M685.618,259.556c-0.146,0-0.252-0.1-0.252-0.254V242.53c0-0.158,0.105-0.26,0.252-0.26h6.485 c3.351,0,5.694,2.162,5.694,5.367c0,3.226-2.344,5.389-5.694,5.389h-3.585c-0.099,0-0.151,0.049-0.151,0.148v6.127 c0,0.154-0.099,0.254-0.257,0.254H685.618z M694.797,247.638c0-1.579-1.098-2.67-2.875-2.67h-3.404 c-0.099,0-0.151,0.049-0.151,0.148v5.035c0,0.102,0.053,0.151,0.151,0.151h3.404C693.7,250.303,694.797,249.237,694.797,247.638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M700.568,242.524c0-0.149,0.104-0.254,0.257-0.254h10.823c0.157,0,0.257,0.104,0.257,0.254v2.191 c0,0.148-0.1,0.252-0.257,0.252h-7.925c-0.105,0-0.154,0.049-0.154,0.15v4.221c0,0.104,0.049,0.149,0.154,0.149h6.682 c0.157,0,0.256,0.105,0.256,0.257v2.187c0,0.149-0.099,0.254-0.256,0.254h-6.682c-0.105,0-0.154,0.052-0.154,0.151v4.373 c0,0.102,0.049,0.154,0.154,0.154h7.925c0.157,0,0.257,0.103,0.257,0.251v2.189c0,0.149-0.1,0.254-0.257,0.254h-10.823 c-0.152,0-0.257-0.104-0.257-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M714.555,250.913c0-2.747,0.1-3.607,0.458-4.676c0.888-2.823,3.073-4.248,5.995-4.248 c2.771,0,4.854,1.425,5.847,3.717c0.047,0.125,0,0.254-0.126,0.303l-2.162,1.043c-0.152,0.075-0.28,0-0.327-0.129 c-0.565-1.217-1.526-2.242-3.231-2.242c-1.648,0-2.615,0.899-3.1,2.291c-0.225,0.716-0.303,1.402-0.303,3.941 c0,2.542,0.078,3.225,0.303,3.94c0.484,1.396,1.451,2.285,3.1,2.285c1.705,0,2.666-1.013,3.231-2.235 c0.047-0.126,0.175-0.201,0.327-0.126l2.162,1.042c0.126,0.05,0.173,0.178,0.126,0.307c-0.992,2.289-3.076,3.71-5.847,3.71 c-2.922,0-5.107-1.421-5.995-4.247C714.655,254.526,714.555,253.657,714.555,250.913"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M729.68,242.524c0-0.149,0.1-0.254,0.254-0.254h2.493c0.149,0,0.251,0.104,0.251,0.254v16.78 c0,0.149-0.102,0.254-0.251,0.254h-2.493c-0.154,0-0.254-0.104-0.254-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M740.965,242.526c0.053-0.154,0.154-0.256,0.332-0.256h2.342c0.169,0,0.273,0.102,0.326,0.256l5.85,16.775 c0.053,0.152,0,0.254-0.181,0.254h-2.487c-0.181,0-0.283-0.078-0.336-0.254l-1.141-3.357h-6.51l-1.144,3.357 c-0.05,0.176-0.151,0.254-0.327,0.254h-2.469c-0.176,0-0.229-0.102-0.176-0.254L740.965,242.526z M744.754,253.277l-2.286-6.711 h-0.073l-2.317,6.711H744.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M752.179,242.524c0-0.149,0.105-0.254,0.257-0.254h2.487c0.151,0,0.257,0.104,0.257,0.254v14.186 c0,0.102,0.053,0.154,0.151,0.154h7.931c0.152,0,0.254,0.103,0.254,0.251v2.189c0,0.149-0.102,0.254-0.254,0.254h-10.826 c-0.151,0-0.257-0.104-0.257-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M766.038,242.524c0-0.149,0.097-0.254,0.258-0.254h2.48c0.158,0,0.257,0.104,0.257,0.254v16.78 c0,0.149-0.099,0.254-0.257,0.254h-2.48c-0.161,0-0.258-0.104-0.258-0.254V242.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M771.934,257.548c-0.1-0.1-0.151-0.254-0.049-0.38l1.578-1.827c0.094-0.129,0.248-0.129,0.351-0.032 c1.121,0.89,2.772,1.83,4.705,1.83c2.062,0,3.252-1.039,3.252-2.487c0-1.246-0.759-2.057-3.149-2.391l-0.914-0.125 c-3.333-0.461-5.216-2.063-5.216-4.936c0-3.123,2.292-5.207,5.85-5.207c2.163,0,4.221,0.686,5.593,1.725 c0.125,0.105,0.151,0.205,0.049,0.359l-1.22,1.877c-0.104,0.128-0.228,0.154-0.356,0.081c-1.395-0.917-2.693-1.351-4.139-1.351 c-1.757,0-2.727,0.971-2.727,2.316c0,1.191,0.844,2.006,3.182,2.338l0.917,0.129c3.325,0.455,5.155,2.029,5.155,5.006 c0,3.074-2.21,5.362-6.504,5.362C775.747,259.836,773.283,258.82,771.934,257.548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M791.614,259.556c-0.158,0-0.258-0.1-0.258-0.254v-14.186c0-0.1-0.049-0.148-0.151-0.148h-4.524 c-0.151,0-0.254-0.104-0.254-0.254v-2.184c0-0.158,0.103-0.26,0.254-0.26h12.35c0.155,0,0.258,0.102,0.258,0.26v2.184 c0,0.15-0.103,0.254-0.258,0.254h-4.521c-0.102,0-0.151,0.049-0.151,0.148v14.186c0,0.154-0.097,0.254-0.251,0.254H791.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M800.842,257.548c-0.102-0.1-0.151-0.254-0.052-0.38l1.579-1.827c0.102-0.129,0.251-0.129,0.354-0.032 c1.12,0.89,2.77,1.83,4.699,1.83c2.063,0,3.258-1.039,3.258-2.487c0-1.246-0.766-2.057-3.153-2.391l-0.913-0.125 c-3.33-0.461-5.211-2.063-5.211-4.936c0-3.123,2.283-5.207,5.844-5.207c2.16,0,4.225,0.686,5.596,1.725 c0.125,0.105,0.148,0.205,0.044,0.359l-1.214,1.877c-0.105,0.128-0.229,0.154-0.356,0.081c-1.401-0.917-2.697-1.351-4.146-1.351 c-1.757,0-2.72,0.971-2.72,2.316c0,1.191,0.841,2.006,3.176,2.338l0.917,0.129c3.33,0.455,5.163,2.029,5.163,5.006 c0,3.074-2.216,5.362-6.507,5.362C804.652,259.836,802.186,258.82,800.842,257.548"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.2,
    y: 113.577,
    fill: "#FFFFFF",
    width: 29.454,
    height: 4.363
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M596.23,117.94h32.206c0.287-1.337,0.488-2.781,0.578-4.363H599.51 C599.143,115.848,597.917,117.179,596.23,117.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M587.654,105.06h2.31c3.674,0,7.002,0.396,8.625,2.878h30.355c-1.564-18.214-16.681-25.22-34.363-25.22 H558.2v25.22h29.454V105.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M613.042,133.037v-0.647c6.369-2.096,10.669-4.686,13.211-8.789h-68.057v40.891h29.457v-26.247h0.549 l13.188,26.247h34.735l-18.027-26.574C616.449,135.532,614.581,134.233,613.042,133.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M679.254,82.532c-19.066,0-35.535,9.588-42.408,25.405h84.816 C714.786,92.12,698.321,82.532,679.254,82.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M668.499,113.577h-33.62c-0.382,1.412-0.686,2.872-0.925,4.363h31.424 C666.157,116.294,667.211,114.826,668.499,113.577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M693.133,117.94h31.416c-0.233-1.491-0.537-2.945-0.916-4.363h-33.62 C691.297,114.826,692.354,116.294,693.133,117.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M694.661,123.606c0.058,0.574,0.087,1.161,0.087,1.76c0,9.328-6.369,15.725-15.49,15.725 c-9.128,0-15.497-6.396-15.497-15.725c0-0.599,0.029-1.186,0.088-1.76h-30.391c-0.012,0.438-0.033,0.881-0.033,1.33 c0,26.241,20.549,41.969,45.833,41.969c25.274,0,45.829-15.728,45.829-41.969c0-0.449-0.023-0.893-0.035-1.33H694.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M813.704,117.94v-4.363h-28.567c0.12,1.453,0.283,2.91,0.479,4.363H813.704z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "777.261,113.577 730.615,113.577 730.615,117.94 779.865,117.94  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M786.464,123.606c0.313,1.861,0.647,3.719,0.976,5.551h-0.885l-3.318-5.551H759l25.908,41.994h28.795 v-41.994H786.464z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.909,
    y: 83.74,
    fill: "#FFFFFF",
    width: 28.795,
    height: 24.106
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M730.612,123.606v41.994h28.798v-26.565c0-5.12-0.782-10.146-1.702-15.429H730.612z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "759.518,83.833 730.615,83.833 730.615,107.938 773.899,107.938  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.077,
    y: 113.577,
    fill: "#FFFFFF",
    width: 30.115,
    height: 4.363
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.479,
    y: 82.718,
    fill: "#FFFFFF",
    width: 63.305,
    height: 25.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.077,
    y: 123.606,
    fill: "#FFFFFF",
    width: 30.115,
    height: 40.885
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M911.844,185.664c0.149-1.234,0.223-2.487,0.223-3.757c0-1.305-0.079-2.582-0.234-3.844h-19.227 c0.374,1.215,0.572,2.508,0.572,3.844c0,1.305-0.192,2.563-0.543,3.757H911.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M911.844,185.664c0.149-1.234,0.223-2.487,0.223-3.757c0-1.305-0.079-2.582-0.234-3.844h-19.227 c0.374,1.215,0.572,2.508,0.572,3.844c0,1.305-0.192,2.563-0.543,3.757H911.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M902.952,109.116c-33.568,0-60.78,27.213-60.78,60.777c0,33.567,27.212,60.779,60.78,60.779 c33.566,0,60.776-27.212,60.776-60.779C963.728,136.329,936.518,109.116,902.952,109.116z M847.989,181.907 c0-17.691,14.35-32.034,32.04-32.034c4.667,0,9.101,0.998,13.101,2.794c9.234,4.141,16.155,12.539,18.258,22.693h-19.954 c-2.271-3.949-6.523-6.605-11.404-6.605c-7.265,0-13.155,5.891-13.155,13.152c0,7.266,5.891,13.156,13.155,13.156 c4.948,0,9.262-2.735,11.509-6.783h19.89c-2.066,10.236-9.007,18.703-18.298,22.875c-4,1.786-8.434,2.652-13.101,2.652 C862.338,213.808,847.989,199.603,847.989,181.907z M925.292,213.835c-4.67,0-9.101-0.182-13.1-1.977v1.967l-19.066-0.006 c10.613-4.343,18.594-13.672,20.865-25.181c2.291,3.847,6.494,6.421,11.301,6.421c7.257,0,13.146-5.887,13.146-13.152 c0-7.262-5.89-13.152-13.146-13.152c-4.807,0-9.01,2.58-11.301,6.425c-2.271-11.513-10.252-20.978-20.865-25.321v-35.414 c3.098-0.52,6.285-0.785,9.537-0.785c3.239,0,6.43,0.266,9.529,0.785v38.223c3.999-1.799,8.43-2.797,13.1-2.797 c17.689,0,32.035,14.346,32.035,32.037C957.327,199.603,942.981,213.835,925.292,213.835z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M951.948,242.323h-2.896v4.278h2.511c1.681,0,3.45-0.12,3.45-2.245 C955.012,242.439,953.542,242.323,951.948,242.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M879.909,241.938h-3.041v4.191h3.398c1.208,0,2.859-0.202,2.859-2.093 C883.125,242.705,882.387,241.938,879.909,241.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M903.78,241.672c-1.648,0-4.186,1.095-4.186,5.788s2.537,5.782,4.186,5.782 c1.658,0,4.197-1.089,4.197-5.782S905.438,241.672,903.78,241.672z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M832.77,234.444v26.014h140.356v-26.014H832.77z M865.682,257.997h-4.098l-0.207-2.157 c-1.451,1.862-3.687,2.662-5.992,2.662c-6.227,0-10.067-4.843-10.067-10.835c0-8.035,5.636-11.252,10.388-11.252 c5.377,0,8.771,2.924,9.715,7.887h-6.224c-0.239-1.539-1.544-2.627-3.076-2.627c-4.457,0-4.312,4.69-4.312,6.139 c0,1.979,0.803,5.432,4.755,5.432c1.507,0,3.044-0.771,3.362-2.332h-2.859v-4.516h8.615V257.997z M883.78,257.997 c-0.333-1.065-0.443-2.157-0.537-3.246c-0.17-2.005-0.35-4.104-2.922-4.104h-3.453v7.35h-6.491v-21.083h12.37 c3.689,0,6.877,2.043,6.877,6.03c0,2.18-1.004,4.486-3.164,5.283c1.777,0.678,2.866,2.624,3.105,5.251 c0.085,1.036,0.117,3.546,0.707,4.519H883.78z M903.78,258.502c-6.4,0-10.684-4.606-10.684-11.042s4.283-11.043,10.684-11.043 c6.413,0,10.689,4.607,10.689,11.043S910.193,258.502,903.78,258.502z M937.814,249.848c0,5.849-3.155,8.654-9.591,8.654 c-6.437,0-9.63-2.806-9.63-8.654v-12.931h6.501v11.486c0,2.15,0,4.839,3.16,4.839c3.068,0,3.068-2.688,3.068-4.839v-11.486h6.491 V249.848z M952.887,251.619h-3.836v6.378h-6.491v-21.083h10.858c5.735,0,7.74,4.197,7.74,7.206 C961.159,249.229,957.733,251.619,952.887,251.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M450.739,200.405c4.799-2.396,8.044-6.848,8.044-12.324c0-12.744-11.55-15.481-22.071-15.315h-28.574 v61.095h29.347c13.091,0,23.778-4.457,23.778-18.996C461.262,207.933,457.254,202.281,450.739,200.405 M424.054,185.087h12.314 c3.332,0,6.501,1.456,6.501,5.901c0,4.366-3.77,5.823-6.501,5.823h-12.314V185.087z M436.796,221.111h-12.742V207.08h12.742 c4.787,0,8.56,1.789,8.56,7.187C445.356,219.304,441.844,221.111,436.796,221.111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.538,
    y: 172.771,
    fill: "#FFFFFF",
    width: 15.916,
    height: 61.089
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M555.593,172.769l-21.071,56.344v-8.947h-28.486v-47.396h-15.914v61.09h42.631h1.77h14.57l3.851-10.958 h21.302l3.766,10.958h16.585l-22.831-61.09H555.593z M556.626,211.105l6.923-21.396h0.17l6.754,21.396H556.626z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "633.381,210.417 633.217,210.417 612.006,172.769 595.652,172.769 595.652,233.858  610.628,233.858 610.628,195.79 610.803,195.79 632.021,233.858 648.364,233.858 648.364,172.769 633.381,172.769  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M684.061,185.18c6.676,0,11.472,3.249,12.327,9.405h15.907c-0.417-14.718-14.711-23.095-27.881-23.095 c-18.482,0-30.458,14.11-30.458,31.825c0,17.711,11.976,31.82,30.458,31.82c15.479,0,27.037-9.238,27.881-24.984h-15.907 c-0.596,7.021-4.88,11.301-12.327,11.301c-10.254,0-14.199-9.074-14.199-18.137C669.862,194.245,673.807,185.18,684.061,185.18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.386,
    y: 172.771,
    fill: "#FFFFFF",
    width: 15.917,
    height: 61.089
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M757.553,172.769l-22.84,61.09h16.348l3.845-10.958h21.308l3.766,10.958h16.591l-22.837-61.09H757.553z  M758.586,211.105l6.926-21.396h0.188l6.748,21.396H758.586z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.795,
    y: 172.771,
    fill: "#FFFFFF",
    width: 15.908,
    height: 61.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 108.734,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 120.19,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 131.642,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 143.093,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.195
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 154.546,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.198
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 166,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.194
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 177.456,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 188.91,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 200.36,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.195
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 211.817,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.191
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.77,
    y: 223.265,
    fill: "#FFFFFF",
    width: 140.356,
    height: 2.195
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightronWhite);
export default __webpack_public_path__ + "static/media/weightron-white.98fa893fc108ecc043c032444e01d911.svg";
export { ForwardRef as ReactComponent };